module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "hosting-plans"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "plan"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('div', {
    staticClass: "inside"
  }, [_vm._v("\n              $" + _vm._s(_vm.allWeekPrice)), _c('br'), _vm._v(" "), _c('span', [_vm._v("/week")])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('purchase-button', {
    attrs: {
      "package": _vm.allWeek,
      "color": "grey"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "plan"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('div', {
    staticClass: "inside"
  }, [_vm._v("\n              $" + _vm._s(_vm.allTwoPrice)), _c('br'), _vm._v(" "), _c('span', [_vm._v("/2 weeks")])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('purchase-button', {
    attrs: {
      "package": _vm.allTwo,
      "color": "yellow"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "plan no-margin"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('div', {
    staticClass: "inside1"
  }, [_vm._v("\n              $" + _vm._s(_vm.allMonthPrice)), _c('br'), _vm._v(" "), _c('span', [_vm._v("/month")])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('purchase-button', {
    attrs: {
      "package": _vm.allMonth,
      "color": "blue"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "home-colums"
    }
  }, [_c('div', {
    staticClass: "colum"
  }, [_c('h3', [_vm._v("Sports Picks")]), _vm._v(" "), _c('p', [_vm._v("\n            Welcome to Stumpthespread.com. STS is home to expert sports\n            betting picks with over a decade in the industry. We offer a daily\n            1 unit free pick bet and anaylsis which is enjoyed by thousands of\n            our committed members in our free pick area. For those looking to\n            take their profits to the next level we recommend trying out an\n            All-Sport Premium memberships or a Full-Season sport specific\n            package. We offer numerous sports pick packages for our diverse\n            cross-section of users from the NFL, NBA, MLB, NHL, NCAAF, and\n            NCAAB. We're committed to providing our members with high quality\n            matchup analysis and our take on the top leans of the day for\n            picks against the spread, straight up, and over/unders. Consider\n            joining our team by becoming a free or premium member today\n            through a hassle free registration!\n          ")]), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "big-btn red",
    attrs: {
      "to": {
        path: 'packages/all'
      }
    }
  }, [_vm._v("\n              Learn More\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "colum"
  }, [_c('h3', [_vm._v("Why Us ?")]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "services-list"
    }
  }, [_vm._m(6), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "sprite chart_bar icon"
  }), _vm._v("\n              " + _vm._s(_vm.count) + " members and counting!\n            ")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "9391510273",
      "ad-style": "display:inline-block;width:180px;height:150px",
      "ad-format": "auto"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "colum no-margin"
  }, [_c('h3', [_vm._v("Happy Customers")]), _vm._v(" "), (_vm.testimonial) ? _c('blockquote', [_c('div', {
    staticClass: "image sprite me2 alignleft"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.testimonial.content))]), _vm._v(" "), _c('div', {
    staticClass: "sprite testimony-bg"
  }), _vm._v(" "), _c('cite', [_vm._v(_vm._s(_vm.testimonial.author) + ",  "), _c('b', [_vm._v(_vm._s(_vm.testimonial.type))])])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn red",
    attrs: {
      "to": {
        path: '/testimonials'
      }
    }
  }, [_vm._v("\n            More Testimonials\n          ")]), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "9391510273",
      "ad-style": "display:inline-block;width:180px;height:150px",
      "ad-format": "auto"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("1 Week of Premium Picks")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("1 Week")]), _vm._v(" "), _c('li', [_vm._v("Premium Access")]), _vm._v(" "), _c('li', [_vm._v("In-Depth Analysis")]), _vm._v(" "), _c('li', [_vm._v("All Sports Included!")]), _vm._v(" "), _c('li', [_vm._v("Picks Emailed or Texted")]), _vm._v(" "), _c('li', [_vm._v("And So Much More..")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("2 Weeks of Premium Picks")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("2 Weeks")]), _vm._v(" "), _c('li', [_vm._v("Premium Access")]), _vm._v(" "), _c('li', [_vm._v("In-Depth Analysis")]), _vm._v(" "), _c('li', [_vm._v("All Sports Covered")]), _vm._v(" "), _c('li', [_vm._v("Picks Emailed or Texted")]), _vm._v(" "), _c('li', [_vm._v("And So Much More..")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("1 Month of Premium Picks")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Best Value")]), _vm._v(" "), _c('li', [_vm._v("Premium Access")]), _vm._v(" "), _c('li', [_vm._v("In-Depth Analysis")]), _vm._v(" "), _c('li', [_vm._v("All Sports are Covered")]), _vm._v(" "), _c('li', [_vm._v("Picks Emailed or Texted")]), _vm._v(" "), _c('li', [_vm._v("And So Much More..")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "sprite coins icon"
  }), _vm._v("\n              High quality premium picks\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "sprite iphone icon"
  }), _vm._v("\n              Access picks on smartphones and tablets\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "sprite headphone icon"
  }), _vm._v("\n              Excellent customer service!\n            ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-280e1dd9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 489
// module chunks = 1